import {
  CrudBuilderState,
  didError,
  didSucceed,
  getFetchAllSlice as getFetchAllSliceBase,
  hasStarted
} from "seneca-common/utils/apiStates";

type State = CrudBuilderState;

// fetch
function getFetchAllState(state: State) {
  return getFetchAllSliceBase(state);
}

export function locationsAreFetching(state: State): boolean {
  return hasStarted(getFetchAllState(state));
}

export function locationsFetchSucceeded(state: State): boolean {
  return didSucceed(getFetchAllState(state));
}

export function locationsFetchErrored(state: State): boolean {
  return didError(getFetchAllState(state));
}

export function locationsFetchFinished(state: State) {
  return locationsFetchSucceeded(state) || locationsFetchErrored(state);
}
export function locationsNeedFetching(state: State) {
  return !(locationsFetchSucceeded(state) || locationsAreFetching(state));
}
